import Vue from 'vue'

Vue.filter('title', function (value, replacer = '_') {
  if (!value) return ''
  value = value.toString()

  const arr = value.split(replacer)
  const capitalized_array = []
  arr.forEach((word) => {
    if (word.charAt(0)) {
      const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
      capitalized_array.push(capitalized)
    }
  })
  return capitalized_array.join(' ')
})

Vue.filter('comma', function (value) {
  if (value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
  return value
})

Vue.filter('date', function (value) {
  try {
    return new Date(value).format('yyyy-MM-dd')
  } catch (e) {

  }
  return value
})

Vue.filter('hhmm', function (value) {
  return new Date(value).format('hh:mm')
})
